import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { ref, computed, watch } from '@nuxtjs/composition-api'
import { EmptyOrderButton } from './../empty-order-button'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
import { useThemeModel } from '@entities/theme'
import { useCustomLogicModel } from '@shared/model'
import { useCallWaiterModel } from '@entities/call-waiter'
import { AnimatedButtonNew } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyOrder',
  props: {
  status: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  showButtons: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  pageLoaded: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  recipient: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  emits: ['refreshPage', 'toggleMenuFooter'],
  setup(__props, { emit: emits }) {

const props = __props

const callWaiterModel = useCallWaiterModel()





const themeModel = useThemeModel()
const customLogicModel = useCustomLogicModel()

const statusMessage = ref<boolean>(false)

const message = computed(() => statusMessage.value ? 'Заказ успешно оплачен' : 'Ваш заказ появится здесь')

watch(() => props.pageLoaded, () => {
  amplitudeLogEvent(amplitudeEvents.ORDER, { ОтображениеЗаказа: 'Нет заказа' })
  statusMessage.value = props.status
  setTimeout(() => {
    statusMessage.value = false
  }, 3000)
})

const refreshPage = () => {
  emits('refreshPage')
}


return { __sfc: true,callWaiterModel, props, emits, themeModel, customLogicModel, statusMessage, message, refreshPage, EmptyOrderButton, AnimatedButtonNew }
}

})